import { useState } from "react";
import { Link } from "react-router-dom";
import api from "../services/api";

export default function AdminForgotPassword() {
  const [email,   setEmail]   = useState("");
  const [error,   setError]   = useState("");
  const [sent,    setSent]    = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (!email.trim()) { setError("Enter your email"); return; }
    if (!/\S+@\S+\.\S+/.test(email)) { setError("Enter a valid email address"); return; }
    try {
      setLoading(true);
      setError("");
      await api.post("/admin/forgot-password", { email: email.trim() });
      setSent(true);
    } catch {
      // We still show success — backend never reveals whether the email exists.
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  const onKey = (e) => { if (e.key === "Enter") submit(); };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-green-50 to-emerald-100 p-4">
      <div className="w-full max-w-sm mb-4">
        <Link to="/clinic-management/signin" className="inline-flex items-center gap-1.5 text-sm text-green-700 hover:text-green-900 font-medium transition">
          ← Back to Sign In
        </Link>
      </div>

      <div className="bg-white rounded-2xl shadow-xl w-full max-w-sm p-8">
        <div className="text-center mb-8">
          <div className="w-14 h-14 bg-green-600 rounded-2xl flex items-center justify-center mx-auto mb-3 text-white text-2xl font-bold">
            🔒
          </div>
          <h1 className="text-2xl font-bold text-gray-800">Forgot Password</h1>
          <p className="text-sm text-gray-400 mt-1">
            {sent ? "Check your inbox for the reset link" : "We'll email you a link to reset it"}
          </p>
        </div>

        {sent ? (
          <div className="bg-green-50 border border-green-200 text-green-700 rounded-xl px-4 py-3 text-sm text-center">
            If an account exists with that email, a password reset link has been sent. The link expires in 1 hour.
          </div>
        ) : (
          <>
            {error && (
              <div className="bg-red-50 border border-red-200 text-red-600 rounded-xl px-4 py-2 mb-4 text-sm">
                {error}
              </div>
            )}

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
              <input
                className="w-full border border-gray-300 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-green-400 transition"
                placeholder="admin@clinic.com"
                value={email}
                onChange={e => setEmail(e.target.value)}
                onKeyDown={onKey}
                autoFocus
              />
            </div>

            <button
              onClick={submit}
              disabled={loading}
              className="mt-6 w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-3 rounded-xl transition disabled:opacity-60 text-sm"
            >
              {loading ? "Sending…" : "Send Reset Link"}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
